// Prévia ao vivo do anúncio no Instagram e no Google (como na POC).
import { MessageCircle } from 'lucide-react'
import type { Goal } from '@impulso/shared'
import { CTA_LABEL, handleFrom, initials } from './constants'

export function InstagramPreview({ businessName, headline, body, imageUrl, goal }: { businessName: string; headline: string; body: string; imageUrl: string | null; goal: Goal }) {
  const handle = handleFrom(businessName)
  return (
    <div className="preview-ig" style={{ margin: '0 auto' }}>
      <div className="head">
        <span className="avatar sm" style={{ background: '#ffe4ec', color: '#be185d' }}>{initials(businessName)}</span>
        <div><div className="strong">{handle}</div><div className="muted" style={{ fontSize: 11 }}>Patrocinado</div></div>
      </div>
      {imageUrl ? (
        <div className="img" style={{ padding: 0, background: '#f3f4f6' }}>
          <img src={imageUrl} alt="Imagem do anúncio" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        </div>
      ) : (
        <div className="img" style={{ background: 'linear-gradient(135deg, #c4b5fd, #7c3aed)' }}>{headline || 'Escolha uma imagem'}</div>
      )}
      <div className="cta"><span>{CTA_LABEL[goal]}</span><MessageCircle size={16} /></div>
      <div className="caption" style={{ overflowWrap: 'anywhere' }}>
        <b>{handle}</b> {body || <span className="muted">O texto do anúncio aparece aqui.</span>}
        {headline && <div className="strong mt-8">{headline}</div>}
      </div>
    </div>
  )
}

export function GooglePreview({ businessName, headline, body, website, goal }: { businessName: string; headline: string; body: string; website: string | null; goal: Goal }) {
  let domain = `${handleFrom(businessName)}.com.br`
  try { if (website) domain = new URL(website).hostname.replace(/^www\./, '') } catch { /* mantém o padrão */ }
  const clean = headline.replace(/[^\p{L}\p{N}\s|·,.!?-]/gu, '').trim()
  const extras = goal === 'calls' ? 'Ligar · Como chegar · Site' : goal === 'store' ? 'Como chegar · Horários · Ligar' : goal === 'whatsapp' ? 'WhatsApp · Como chegar · Ligar' : goal === 'leads' ? 'Teste grátis · Planos · Contato' : 'Comprar · Ofertas · Contato'
  return (
    <div className="preview-google" style={{ overflowWrap: 'anywhere' }}>
      <div className="sp"><b>Patrocinado</b></div>
      <div className="sp mt-8">
        <span className="avatar sm" style={{ width: 22, height: 22, background: '#ffe4ec', color: '#be185d', fontSize: 9 }}>{initials(businessName)}</span>
        {businessName} · {domain}
      </div>
      <div className="t">{clean || 'Título do anúncio'} | {businessName}</div>
      <div className="d">{body || 'A descrição do anúncio aparece aqui.'}</div>
      <div className="d mt-8" style={{ color: '#1a0dab' }}>{extras}</div>
    </div>
  )
}
